import { t } from 'i18next';
import type { GetApiDoctorsPortalMessages200MessagesItemPriority } from '@/shared/api/models';

export function getPriorityStyles(priority: GetApiDoctorsPortalMessages200MessagesItemPriority): {
    bg: string;
    borderLeft: string;
    border: string;
    badge: string;
} {
    const p = (priority || '').toString().toUpperCase();
    const isCritical = p === 'CRITICAL';
    const isImportant = p === 'IMPORTANT';

    if (isCritical) {
        return {
            bg: 'bg-red-50 dark:bg-red-950/30',
            borderLeft: 'border-solid border-l-red-500',
            border: 'border-[1px] border-solid border-red-500',
            badge: 'bg-red-100 text-red-800 dark:bg-red-900/50 dark:text-red-200',
        };
    }
    if (isImportant) {
        return {
            bg: 'bg-amber-50 dark:bg-amber-950/30',
            borderLeft: 'border-solid border-l-amber-500',
            border: 'border-[1px] border-solid border-amber-500',
            badge: 'bg-amber-100 text-amber-800 dark:bg-amber-900/50 dark:text-amber-200',
        };
    }
    return {
        bg: 'bg-blue-50 dark:bg-blue-950/30',
        borderLeft: 'border-solid border-l-blue-500',
        border: 'border-[1px] border-solid border-blue-500',
        badge: 'bg-blue-100 text-blue-800 dark:bg-blue-900/50 dark:text-blue-200',
    };
}

export function getPriorityLabel(priority: GetApiDoctorsPortalMessages200MessagesItemPriority): string {
    const p = (priority || '').toString().toUpperCase();
    if (p === 'CRITICAL') return t('Doctors.PriorityHigh');
    if (p === 'IMPORTANT') return t('Doctors.PriorityMedium');
    return t('Doctors.PriorityLow');
}
